
import React, { useState, useRef } from 'react';
import { useMask } from '@react-input/mask';
import './FiltroVendas.css';

// Categorias simplificadas para a busca do usuário (com FLAT separado)
export const CATEGORIAS_SIMPLIFICADAS = [
  { label: "Casa (Residencial)", codigos: "10,12,13,14" },
  { label: "Apartamento", codigos: "20,21,22" },
  { label: "Flat (Residencial)", codigos: "25" },
  { label: "Flat (Comercial)", codigos: "85" },
  { label: "Comercial — Escritório/Consultório", codigos: "30,31,32" },
  { label: "Comercial — Loja", codigos: "40,41,42,43" },
  { label: "Garagem em Condomínio (Unid. Autônoma)", codigos: "23,24" },
  { label: "Serviços Automotivos & Garagens", codigos: "60,61,62,63,64" },
  { label: "Industrial / Depósito", codigos: "50,51" },
  { label: "Hotel", codigos: "80" },
  { label: "Institucional / Público", codigos: "70,71,72,73,74,81,82,83,84" },
  { label: "Terreno", codigos: "0" }
];

const FiltroVendas = ({ onSearch }) => {
  const [filters, setFilters] = useState({});
  const [cepRange, setCepRange] = useState(false);
  const [valorRange, setValorRange] = useState(false);
  const [dataRange, setDataRange] = useState(false);

  const cepInputRef = useRef(null);
  const cepInicialInputRef = useRef(null);
  const cepFinalInputRef = useRef(null);

  useMask({ ref: cepInputRef, mask: '_____-___', replacement: { _: /\d/ } });
  useMask({ ref: cepInicialInputRef, mask: '_____-___', replacement: { _: /\d/ } });
  useMask({ ref: cepFinalInputRef, mask: '_____-___', replacement: { _: /\d/ } });

  // Handler para múltipla escolha do Tipo de Uso agrupado
  const handleCategoriaUsoChange = (e) => {
    const selected = Array.from(e.target.selectedOptions).map(opt => opt.value);
    setFilters(prev => ({ ...prev, USO_IPTU: selected }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

    // ...existing code...
const handleSearch = () => {
    const cleanedFilters = { ...filters };
    // Agrupa os códigos das categorias selecionadas
    if (Array.isArray(cleanedFilters.USO_IPTU)) {
      const codigos = cleanedFilters.USO_IPTU
        .map(cat => {
          const found = CATEGORIAS_SIMPLIFICADAS.find(c => c.label === cat);
          return found ? found.codigos : '';
        })
        .filter(Boolean)
        .join(',');
      cleanedFilters.USO_IPTU = codigos;
    }
    if (cleanedFilters.CEP) {
      cleanedFilters.CEP = cleanedFilters.CEP.replace(/\D/g, '');
    }
    if (cleanedFilters.CEP_INICIAL) {
      cleanedFilters.CEP_INICIAL = cleanedFilters.CEP_INICIAL.replace(/\D/g, '');
    }
    if (cleanedFilters.CEP_FINAL) {
      cleanedFilters.CEP_FINAL = cleanedFilters.CEP_FINAL.replace(/\D/g, '');
    }
    // Converter valores para double
    if (cleanedFilters.VALOR_DE_TRANSACAO) {
      cleanedFilters.VALOR_DE_TRANSACAO = parseFloat(
        cleanedFilters.VALOR_DE_TRANSACAO.replace(/\./g, '').replace(',', '.')
      );
    }
    if (cleanedFilters.VALOR_TRANSACAO_INICIAL) {
      cleanedFilters.VALOR_TRANSACAO_INICIAL = parseFloat(
        cleanedFilters.VALOR_TRANSACAO_INICIAL.replace(/\./g, '').replace(',', '.')
      );
    }
    if (cleanedFilters.VALOR_TRANSACAO_FINAL) {
      cleanedFilters.VALOR_TRANSACAO_FINAL = parseFloat(
        cleanedFilters.VALOR_TRANSACAO_FINAL.replace(/\./g, '').replace(',', '.')
      );
    }
    onSearch(cleanedFilters);
  };
  // ...existing code...

  const formatCurrency = (e) => {
    let value = e.target.value;
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d)(\d{2})$/, '$1,$2');
    value = value.replace(/(?=(\d{3})+(\D))\B/g, '.');
    e.target.value = value;
    return e;
  };

  return (
    <div className="filtro-vendas">
      <div className="filtro-vendas-grid">
         <div className="filtro-vendas-input-group">
          <div className="range-toggle">
            <input type="checkbox" id="cep-range-toggle" checked={cepRange} onChange={() => setCepRange(!cepRange)} />
            <label htmlFor="cep-range-toggle">Buscar CEP por faixa</label>
          </div>
          {cepRange ? (
            <div className="range-inputs">
              <input ref={cepInicialInputRef} name="CEP_INICIAL" placeholder="CEP Inicial" onChange={handleChange} />
              <input ref={cepFinalInputRef} name="CEP_FINAL" placeholder="CEP Final" onChange={handleChange} />
            </div>
          ) : (
            <input ref={cepInputRef} name="CEP_INICIAL" placeholder="CEP" onChange={handleChange} />
          )}
        </div>
                
        <div className="filtro-vendas-input-group">
          <label htmlFor="numero">Número</label>
          <input id="numero" type="text" name="NUMERO" placeholder="Ex: 123" onChange={handleChange} />
        </div>
        <div className="filtro-vendas-input-group">
          <label htmlFor="nome-logradouro">Logradouro</label>
          <input id="nome-logradouro" type="text" name="NOME_DO_LOGRADOURO" placeholder="Ex: Av. Paulista" onChange={handleChange} />
        </div>


        <div className="filtro-vendas-input-group">
          <label htmlFor="bairro">Bairro</label>
          <input id="bairro" type="text" name="BAIRRO" placeholder="Ex: Bela Vista" onChange={handleChange} />
        </div>

<div className="filtro-vendas-input-group">
          <div className="range-toggle">
            <input type="checkbox" id="data-range-toggle" checked={dataRange} onChange={() => setDataRange(!dataRange)} />
            <label htmlFor="data-range-toggle">Buscar data por faixa</label>
          </div>
          {dataRange ? (
            <div className="range-inputs">
              <input
                type="date"
                name="DATA_DE_TRANSACAO_INICIAL"
                placeholder="Data Inicial"
                onChange={handleChange}
              />
              <input
                type="date"
                name="DATA_DE_TRANSACAO_FINAL"
                placeholder="Data Final"
                onChange={handleChange}
              />
            </div>
          ) : (
            <input
              type="date"
              name="DATA_DE_TRANSACAO_INICIAL"
              placeholder="Data da Transação"
              onChange={handleChange}
            />
          )}
        </div>

        <div className="filtro-vendas-input-group">
          <label htmlFor="ano-transacao">Ano da Transação</label>
          <input
            id="ano-transacao"
            type="number"
            name="ANO_TRANSACAO"
            placeholder="Ex: 2024"
            min="1900"
            max="2099"
            onChange={handleChange}
          />
        </div>
        <div className="filtro-vendas-input-group">
          <div className="range-toggle">
            <input type="checkbox" id="valor-range-toggle" checked={valorRange} onChange={() => setValorRange(!valorRange)} />
            <label htmlFor="valor-range-toggle">Buscar valor por faixa</label>
          </div>
          {valorRange ? (
            <div className="range-inputs">
              <input type="text" name="VALOR_TRANSACAO_INICIAL" placeholder="Valor Mínimo" onChange={(e) => handleChange(formatCurrency(e))} />
              <input type="text" name="VALOR_TRANSACAO_FINAL" placeholder="Valor Máximo" onChange={(e) => handleChange(formatCurrency(e))} />
            </div>
          ) : (
            <input type="text" name="VALOR_DE_TRANSACAO" placeholder="Valor de Transação" onChange={(e) => handleChange(formatCurrency(e))} />
          )}
        </div>

        <div className="filtro-vendas-input-group" style={{ gridColumn: 'span 2' }}>
          <label htmlFor="categoria-uso-iptu">Tipo de Uso (múltipla escolha)</label>
          <select
            id="categoria-uso-iptu"
            name="USO_IPTU"
            multiple
            value={filters.USO_IPTU || []}
            onChange={handleCategoriaUsoChange}
            style={{ height: '150px' }}
          >
            {CATEGORIAS_SIMPLIFICADAS.map(cat => (
              <option key={cat.label} value={cat.label}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>
        
        <button onClick={handleSearch} className="button-primary">Buscar</button>

      </div>
    </div>
  );
};

export default FiltroVendas;
